import React from "react";
import { Image, Button, Modal }  from 'react-bootstrap';
import Iframe from 'react-iframe';
import SwydgetWyshResults from '../stats/SwydgetWyshResults';
import defaultCardBackgroundImage from '../../assets/swydget/default-card-background.png';

export default class SwydgetProductResults extends React.Component {

  constructor() {
    super();
    this.wysh = {};
    this.eventInFocus = {};
    this.isLiked = this.isLiked.bind(this);
    this.isDisliked = this.isDisliked.bind(this);
    this.openProductLinkModal = this.openProductLinkModal.bind(this);
    this.closeProductLinkModal = this.closeProductLinkModal.bind(this);

    this.state = {
      liked: true,
      showProductLinkModal: false
    };
  };

  isLiked() {
    this.setState({ liked: true });
  }

  isDisliked() {
    this.setState({ liked: false });
  }

  openProductLinkModal() {
    if (this.wysh.product.buyPage === '') {
      this.setState({ showProductLinkModal: true});
    }
    else {
      window.open(this.wysh.product.buyPage, '');
    }

    // THIS WAS OUR SOLUTION TO DISPLAYING VIDEO IN THE MODAL WINDOW
    // if (this.wysh.product.isBuyPageSecure() === true) {
    //   this.setState({ showProductLinkModal: true});
    // }
    // else {
    //   if (this.wysh.product.buyPage !== '') {
    //     window.open(this.wysh.product.buyPage, '');
    //   }
    //   else {
    //     this.setState({ showProductLinkModal: true}); // Kind of lame, but we know here that if the buyPage isn't secure and not '', it will display the product image
    //   }
    // }
  }

  closeProductLinkModal() {
    this.setState({ showProductLinkModal: false });
  }

  getProductLabel(wysh) {

    let textDiv = {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 6,
      paddingRight: 6,
      textAlign: 'center',
      margin: 0,
      color: '#ffffff',
      fontWeight: 800,
      fontSize: 18,
      textShadow: '0px 2px 10px rgba(0, 0, 0, 1)'
    }

    var productLabel = {

    };

    if (wysh.product.name.length > 0) {
      productLabel =
        <div style={textDiv}>
          {wysh.product.name}
        </div>

    }
    else {
      productLabel =
        <div style={textDiv}>
          {wysh.product.name}
        </div>
    }

    return productLabel;
  }

  getPriceLabel(wysh) {

    let priceLabelContainerDivStyle = {
      marginTop: 0,
      marginBottom: 0,
      padding: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 'auto'
    };

    let textDiv = {
      padding: 0,
      margin: 0,
      color: '#ffffff',
      fontWeight: 800,
      fontSize: 18,
      textShadow: '0px 2px 10px rgba(0, 0, 0, 1)'
    }

    var label = <div style={priceLabelContainerDivStyle}></div>

    if (wysh.product.price > 0) {
      label = <div style={priceLabelContainerDivStyle}>
        <div style={textDiv}>
          ${wysh.product.getPrice(2)}
        </div>
      </div>
    }

    return label;
  }

  getQuestionLabel(wysh) {

    let textDiv = {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 6,
      paddingRight: 6,
      textAlign: 'center',
      margin: 0,
      color: '#ffffff',
      fontWeight: 800,
      fontSize: 18,
      textShadow: '0px 2px 10px rgba(0, 0, 0, 1)'
    }

    var label = <div style={textDiv}></div>;

    if (wysh.caption !== this.eventInFocus.title) {
      label =
        <div style={textDiv}>
          {wysh.caption}
        </div>

    }

    return label;
  }

  generateMediaModalContent(cardHeightStyle) {

    if (this.wysh.product.buyPage === '') {

      let containerDivStyle = {
        height: '65vh',
        width: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      };

      let imageStyle = {
        // maxHeight: '100%',
        // maxWidth: '100%'
      };

      return (
        <div style={containerDivStyle}><Image style={imageStyle} src={this.wysh.product.getSecureImageUrl(this.wysh)} responsive="true"/></div>
      );
    } else {
      return (
        <Iframe url={this.wysh.product.buyPage}
          width="100%"
          height={cardHeightStyle}
          display="initial"
          position="relative"
          allowFullScreen/>
      );
    }
  }

  determineFontSize() {
    // if (this.wysh && this.wysh.product.description.length > 80){
      return "2.4vh";
    // }
    // else {
    //   return "3.2vh";
    // }
  }

  getProductImage(wysh, cardHeightStyle, cardWidthStyle) {

    let productCleanImageStyle = {
      width: cardWidthStyle,
      height: cardHeightStyle,
      objectFit: wysh ? wysh.product.styles.objectFit : "cover",
      background: 'linear-gradient(#0167EC, #00B6F9)',
      zIndex: -10
    };

    if (wysh && wysh.product && wysh.product.getSecureImageUrl(wysh) !== "") {
      return <Image src={wysh.product.getSecureImageUrl(wysh)} style={productCleanImageStyle}></Image>
    }
    else {
      return <Image src={defaultCardBackgroundImage} style={productCleanImageStyle}></Image>
    }

  }

  render() {

    const { idx } = this.props;
    this.eventInFocus = this.props.eventInFocus;
    this.wysh = this.props.wysh;

    var cardHeight = 35;
    var cardWidth = cardHeight * (2.5/3.5); // standard card width
    var cardHeightStyle = cardHeight + 'vh';
    var cardWidthStyle = cardWidth + 'vh';

    var textColor = "#000000";
    var textShadow = "0.0vh 0.0vh 0.5vh rgba(255,255,255,1.0)";

    if (this.wysh.product.styles.textShadow && this.wysh.product.styles.textShadow === "light") {
      textColor = "#ffffff";
      textShadow = "0.0vh 0.0vh 0.5vh rgba(0,0,0,1.0)";
    }

    let containerStyle = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      marginBottom: 30
    };

    let cardContainerDivStyle = {
      marginTop: 10,
      marginBottom: 12,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 'auto'
    };

    let wyshDetailDivStyle = {
      padding: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: 6,
      width: cardWidthStyle,
      display: 'flex',
      justifyContent: 'right',
      alignItems: 'center',
      flexDirection: 'column',
      color: '#ffffff'
    }

    let wyshCountDivStyle = {
      padding: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: 20,
      width: cardWidthStyle,
      display: 'flex',
      justifyContent: 'right',
      alignItems: 'center',
      flexDirection: 'column',
      color: '#ffffff'
    }

    let cardStyle = {
      position: 'relative',
      overflow: 'hidden',
      width: cardWidthStyle,
      height: cardHeightStyle,
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      borderRadius: '5%',
      marginBottom: 0,
      WebkitBoxShadow: '0px 3px 25px 10px rgba(0,0,0,0.4)',
      MozBoxShadow: '0px 3px 25px 10px rgba(0,0,0,0.4)',
      boxShadow: '0px 3px 25px 10px rgba(0,0,0,0.4)'
    };

    let nameAndPriceDivStyle = {
      position: 'absolute',
      width: '100%',
      left: 0,
      top: 5,
      paddingLeft: 5,
      paddingRight: 5,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'left'
    }

    let textBoxContainerStyle = {
      margin: 0,
      padding: '1.05vw',
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      top: 0,
      left: 0,
      color: textColor,
      textShadow: textShadow,
      width: cardWidthStyle,
      height: cardHeightStyle,
      fontSize: this.determineFontSize(),
      zIndex: -7
    }

    return (
      <div key={idx} style={containerStyle}>
        <div style={wyshCountDivStyle}>{idx + 1}/{this.eventInFocus.getWyshes().length}</div>
        <div style={wyshDetailDivStyle}>{this.getQuestionLabel(this.wysh)}</div>
        <div key={idx} ref={"card-" + idx} style={cardContainerDivStyle}>
          <div style={cardStyle} onClick={this.openProductLinkModal}>
            <div style={nameAndPriceDivStyle}>

            </div>
            {this.getProductImage(this.wysh, cardHeightStyle, cardWidthStyle)}
            <div style={textBoxContainerStyle}>
              {this.wysh.product.description}
            </div>
          </div>
        </div>
        <SwydgetWyshResults wysh={this.wysh} />


        <Modal show={this.state.showProductLinkModal} onHide={this.closeProductLinkModal}>
          <Modal.Header closeButton>
            <Modal.Title>{this.wysh.product.name}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              {this.generateMediaModalContent(cardHeightStyle)}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.closeProductLinkModal}>Close</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
